import { render } from "./homeCareSection.vue?vue&type=template&id=53b5dfb0&scoped=true"
import script from "./homeCareSection.vue?vue&type=script&lang=js"
export * from "./homeCareSection.vue?vue&type=script&lang=js"

import "./homeCareSection.vue?vue&type=style&index=0&id=53b5dfb0&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b5dfb0"]])

export default __exports__